<template>
  <div style="width: 1200px; margin-left: auto; margin-right: auto;">
    <p class="p-a">欢迎访问虹通官网</p>
    <p>虹通是我们团队用4年时间精心为您打造的混合云平台, 核心代码使用c语言编写, 帮助您完全掌控数据主权</p>
    <p>虹通帮助你无感的访问共有网络服务和私有网络服务, 虹通混合云平台常见的应用场景如下:</p>

    <div class="parent-container" style="margin-top: 30px;">
      <div class="child-overlay">
        <!-- 按钮组 -->
        <button @click="showImage(0)" class="btn btn-primary" style="margin-right: 5px;">1</button>
        <button @click="showImage(1)" class="btn btn-secondary" style="margin-right: 5px;">2</button>
        <button @click="showImage(2)" class="btn btn-success">3</button>
      </div>
  
      <!-- 图片展示区域 -->
      <div class="mt-3">
        <img v-if="currentImageIndex === 0" src="../assets/case_1.png" class="img-fluid" alt="图片 1">
        <img v-else-if="currentImageIndex === 1" src="../assets/case_2.png" class="img-fluid" alt="图片 2">
        <img v-else-if="currentImageIndex === 2" src="../assets/case_3.png" class="img-fluid" alt="图片 3">
        <div v-else>请选择一张图片</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      currentImageIndex: 0 // 0, 1, 2
    };
  },
  methods: {
    showImage(index) {
      this.currentImageIndex = index;
    }
  }
};
</script>

<style scoped>
.p-a {
  margin-top: 25px;
  margin-bottom: 10px;
  color: #2185d0!important;
  font-weight: bold;
  font-size: 24px;
}

.parent-container {
  position: relative; /* 1. 父元素设置相对定位 */
  width: 900px;
}

.child-overlay {
  position: absolute; /* 2. 子元素设置绝对定位 */
  top: 0;             /* 3. 距离父元素顶部0 */
  left: 0;            /* 4. 距离父元素左侧0 */
  background-color: rgba(255, 0, 0, 0.5); /* 半透明红色 */
  color: white;
  padding: 5px;
}

</style>
